function Solutions(){
    return (<div class="container">
        <div class="section">
            <h2>Solutions Available</h2>
            <ul>
                <li>Power Solutions</li>
                <li>Backup Solutions</li>
                <li>Earthing & Bonding Solutions</li>
            </ul>
        </div>
    </div>)
}

export default Solutions;